<script setup lang="ts">
import backdropUrl from "./backdrop.png"
</script>
<template>
    <main aria-labelledby="ueber-uns">
        <h1 id="ueber_uns" class="sr-only">Über uns</h1>

        <div class="container" role="presentation">
            <div class="breadcrumb" aria-hidden="true">
                <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
                <div class="breadcrumb-item">Über uns</div>
            </div>

            <div class="teaser" role="presentation">
                <article class="teaser-text">
                    <h2>CANN24</h2>
                    <h3>Erfahrung zeichnet uns aus</h3>

                    <p class="mb-0">
                        Die apotheke am inselpark war bereits vor der Möglichkeit Cannabis auf Rezept zu verordnen ein
                        kompetenter Ansprechpartner für Cannabispatienten. Bereits kurz nach Gründung der neuen Apotheke
                        und Aufnahme des Geschäftsbetriebes zum Jahresbeginn 2014 waren wir im Besitz einer
                        Ausnahmegenehmigung zum Erwerb und Abgabe von Cannabis zu medizinischen Zwecken an entsprechende
                        Patienten. 2017 hat der Gesetzgeber dann die Möglichkeit geschaffen, Cannabis auf Rezept zu
                        verordnen und der Bedarf steigt seitdem stetig. Damals wie heute steht der Patient als Mensch im
                        Zentrum unserer Serviceleistungen. Unser Anspruch ist es Patienten, die Cannabispräparate
                        verordnet bekommen haben, den Erhalt ihrer Arznei zu ermöglichen, wie man es von einer Apotheke
                        erwarten darf. Diskret, freundlich, kompetent und vorurteilsfrei. Unsere Lagerhaltung ermöglicht
                        meist eine sofortige Belieferung der Rezepte. Keine lästigen und längeren Wartezeiten.
                        Lieferengpässe der Hersteller versuchen wir dadurch ebenfalls bestmöglich abzufedern.
                    </p>
                </article>

                <div class="teaser-image" aria-hidden="true">
                    <img src="./about-us-01.png" class="img-fluid" alt="" />
                </div>
            </div>

            <article>
                <p class="pb-5">
                    Wir sind im Besitz einer Versandhandelserlaubnis und versorgen dadurch gerne auch Patienten, die
                    nicht in Hamburg und Umgebung wohnen und auf der Suche nach einem verlässlichen Partner bei der
                    Versorgung mit ihrer Arznei sind. Mit CANN24.de steht nun außerdem ein Online-Portal bereit, auf dem
                    registrierte Patienten ihre Bestellungen tätigen können und themenbezogene Hilfe und Aufklärung
                    erhalten können. Wir freuen uns, wenn wir auch dich von unseren Leistungen überzeugen dürfen.
                </p>
            </article>
        </div>
        <!--    <div class="container-fluid bg-light py-5">-->
        <!--        <div class="container">-->
        <!--            <div class="teaser bg-light pt-md-4 pb-0 pt-1 align-items-start">-->
        <!--                <div class="teaser-image">-->
        <!--                    <img src="./about-us-02.jpg" alt="" class="img-fluid">-->
        <!--                </div>-->

        <!--                <div class="teaser-text pb-0">-->
        <!--                    <h2>Patienten-Lounge</h2>-->
        <!--                    <h1>Ein Ort für besondere Beratung</h1>-->

        <!--                    <p>-->
        <!--                        Unsere Patienten-Lounge öffnet über den Dächern von Wilhelmsburg ihre Tore zu einer neuen-->
        <!--                        Beratungswelt. In angenehmer Atmosphäre klären wir deine Fragen rund um das Thema Cannabis als-->
        <!--                        Medizin und zu deiner Therapie. Hier können wir dir fern von unerwünschten Blicken anderer-->
        <!--                        Kunden bei Individualterminen z.B. Hilfsmittel vorführen. Kalt- und Heißgetränke stehen zur-->
        <!--                        Verfügung. Eine Dachterrasse lädt im (kurzen) Hamburger Sommer zum Aufenthalt bei frischer Luft-->
        <!--                        ein. Wer nicht aus Zucker ist, kann natürlich auch an den zahlreichen regnerischen Tagen den-->
        <!--                        Ausblick genießen. Aber keine Sorge, der Arzneigebrauch ist selbstverständlich auch im-->
        <!--                        Innenbereich möglich.-->

        <!--                        Regelmäßig finden hier auch Infoveranstaltungen statt – für Patienten, aber auch für Ärzte und-->
        <!--                        andere Fachgruppen.-->
        <!--                    </p>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--            <p>-->
        <!--                Wie kommst du rein? Die Lounge steht – Sonderveranstaltungen ausgenommen – nur unseren Patienten offen.-->
        <!--                Registriere dich am besten noch heute bei uns und werde Teil der CANN24-Community. Unseren-->
        <!--                Patientenausweis solltest du auch besitzen. Er ist deine Eintrittskarte. Am besten jetzt beantragen.-->
        <!--            </p>-->
        <!--        </div>-->
        <!--    </div>-->

        <div
            class="about-us-backdrop footer-flush-element"
            :style="{ backgroundImage: `url(${backdropUrl})` }"
            role="presentation"
        >
            <article class="container text-center">
                <img
                    src="@/shop/assets/logo/apotheke-am-inselpark.png"
                    alt=""
                    style="max-width: 80%; max-height: 80px"
                />

                <p class="mt-3 mb-5 px-5"></p>
                <h2>Wir können auch anders!</h2>

                Natürlich verbirgt sich hinter CANN24 eine (besondere) Apotheke. Wir sind selbstverständlich auch in
                allen anderen Fragen dein Ansprechpartner für Arzneimittel. Besuche uns doch einfach vor Ort oder schau
                dir mal unsere Apotheke online an.
                <p></p>

                <a class="btn btn-primary" href="//www.apotheke-inselpark.de" target="_blank"
                    >Zur Apotheke am Inselpark</a
                >
            </article>
        </div>
    </main>
</template>

<style scoped>
.about-us-backdrop {
    background: #f8f8f9 no-repeat center;
    background-size: cover;
    padding: 5rem 0;
}
</style>
